
<component :is="tag" :class="classes" :role="role">
  <slot></slot>
</component>
